import { DatePipe } from "@angular/common";
import { Component } from "@angular/core";
import { MDBModalRef, MDBModalService } from "angular-bootstrap-md";
import { Subject } from "rxjs";
import { ModalMessageComponent } from "src/app/modals/modal-message/modal-message.component";
import { CompanyService } from "../../service/company.service";
import { ValidatorUtils } from "src/app/utils/validator.utils";
import { Md5 } from "md5-typescript";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ModalFormCreateQuestionComponent } from "../modal-form-create-question/modal-form-create-question.component";
import { ModalChoiceComponent } from "../modal-choice/modal-choice.component";
import { ModalFormPermissionsComponent } from "../modal-form-permissions/modal-form-permissions.component";
import { EmailTemplateService } from "src/app/service/emailtemplate.service";
import { UserService } from "src/app/service/user.service";

@Component({
  selector: "modal-email-template-send",
  templateUrl: "./modal-email-template-send.component.html",
  styleUrls: ["./modal-email-template-send.component.css"],
})
export class ModalEmailTemplateSendComponent {
  url: string = "https://www.mmlpqtpkasjdashdjahd.com";
  urlSafe: SafeResourceUrl;
  constructor(
    public modalRef: MDBModalRef,
    public sanitizer: DomSanitizer,
    private modalService: MDBModalService,
    private emailTemplateService: EmailTemplateService,
    private userService: UserService
  ) {}

  action: Subject<any> = new Subject();
  modalRef2: MDBModalRef;

  title: string = "";
  patientsFull = [];
  patients = [];

  selected_patients = null;
  email_template_clone;
  is_new: boolean;
  id: string = "";
  loading: boolean = false;
  templateId: string = "";
  validator = new ValidatorUtils();

  ngOnInit() {
    this.getPatients(1);
  }

  isEmpty(str) {
    if (!str || !str.length) {
      return true;
    }
    return false;
  }

  getPatients(page, search = null) {
    this.loading = true
    this.userService.getPatientsPagination(page).subscribe(
      (data) => {
        this.loading = false
        // //console.log(data.results)

        // pagination calc
        data = data.filter((item) => item.is_doctor === false)
        this.patientsFull = data;
        this.patients = data;

        try{
          localStorage.setItem("patients", JSON.stringify(data));
        } catch {
          
        }
        

        // console.log(this.page, this.count_total, this.page_size)

        data.sort((a, b) => a.name.localeCompare(b.name));
        this.patientsFull = data;
        // console.log(this.page_count1, )
        
      },
      (error) => {
        this.loading = false
      }
    );
  }

  accentFold(inStr) {
    return inStr.replace(
      /([àáâãäå])|([çčć])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/g,
      function (str, a, c, e, i, n, o, s, u, y, ae) {
        if (a) return "a";
        if (c) return "c";
        if (e) return "e";
        if (i) return "i";
        if (n) return "n";
        if (o) return "o";
        if (s) return "s";
        if (u) return "u";
        if (y) return "y";
        if (ae) return "ae";
      }
    );
  }

  selectSearchPatient(value: string) {
    this.patients = [];
    let filter = this.accentFold(value.toLowerCase());
    for (let i = 0; i < this.patientsFull.length; i++) {
      let option = this.patientsFull[i];
      if (this.accentFold(option.name.toLowerCase()).indexOf(filter) >= 0) {
        this.patients.push(option);
      }
    }
  }

  submit() {
    if (!this.selected_patients || !this.selected_patients.length)  {
      this.openMessage("Erro", "Você precisa selecionar pelo menos um paciente");
      return;
    }

    //console.log(form);

    this.loading = true;
    this.emailTemplateService.sendMail(this.templateId, {patients: this.selected_patients}).subscribe(
      (data) => {
        this.openMessage("Sucesso", "E-mail(s) enviado(s) com sucesso!");
        this.action.next(true);
        this.modalRef.hide();
      },
      (error) => {
        let msg = "Ocorreu um erro, tente novamente";
        if (
          error.response &&
          error.response.data &&
          error.response.data.non_field_errors &&
          error.response.data.non_field_errors.length > 0
        ) {
          msg = error.response.data.non_field_errors[0];
        }
        this.openMessage("Erro", msg);

        this.loading = false;
      }
    );
   
  }

  openMessage(title, text, bgclick: boolean = false) {
    this.modalRef2 = this.modalService.show(ModalMessageComponent, {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: true,
      ignoreBackdropClick: bgclick,
      class: "modal-dialog-centered modal-dialog",
      containerClass: "",
      animated: false,
      data: {
        title: title,
        text: text,
      },
    });
  }

  selectAllPatients() {
    if (
      this.selected_patients &&
      this.selected_patients.length === this.patients.length
    ) {
      this.selected_patients = [];
    } else {
      this.selected_patients = this.patients.map((c) => c.id);
    }
  }
}
